module.exports = __webpack_public_path__ + "img/Wizard.0afd0a27.png";